
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { camelizeKeys } from 'humps'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { PaymentIcons } from '@payment'

import translations from './SellerBlock.translations'

export default {
  components: {
    RevLink,
    RevIllustration,
    PaymentIcons,
  },
  props: {
    grade: {
      type: Object,
      default: () => ({}),
    },
    seller: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,

    ...mapGetters({
      countryPaymentMethods: 'countryConfig/paymentMethods',
    }),

    paymentMethods() {
      return isEmpty(this.grade.paymentMethods)
        ? this.countryPaymentMethods
        : camelizeKeys(this.grade.paymentMethods)
    },
  },
}
